var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkSolidIcon = function SvgCheckmarkSolidIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.646.168a.87.87 0 0 1 .19 1.208L4.98 10.893a.86.86 0 0 1-.627.354.84.84 0 0 1-.672-.252L.25 7.536a.87.87 0 0 1 0-1.225.853.853 0 0 1 1.214 0l2.718 2.744L10.451.357A.85.85 0 0 1 11.65.165z"
  })));
};
export default SvgCheckmarkSolidIcon;